(function(angular) {
    angular.module('bizPartEngage').service('modules.education.service', educationService);
    //THIS FOR BACKWORDS COMPABILITY
    angular.module('bizPartEngage').service('BizOnlineEducationReplyService', educationService);
    //angular.module('bizPartEngage').service('modules.education.service.reply', [replyService]);
    //THIS FOR BACKWORDS COMPABILITY
    angular.module('bizPartEngage').service('BizOnlineEducationReplyService', [replyService]);

    educationService.$inject = ["$http"];

    function educationService($http) {
        this.GetCompletedCount = function() {
            return $http.get(siteRootPath + 'api/education/GetCompletedCount');
        };

        this.GetHTML5EducationsForLoggedInUser = function (skipLoadContainer, journeyOrder) {
            return $http.get(siteRootPath + 'api/education/GetHTML5EducationsForLoggedInUser?' + $.param({ skipLoadContainer: skipLoadContainer === undefined ? false : true, journeyOrder: journeyOrder || false  }));
        };

        this.GetHTML5EducationsForLoggedInUserByTagId = function (id, journeyOrder) {
            return $http.get(siteRootPath + "api/education/GetHTML5EducationsForLoggedInUserByTagId?" + $.param({ tagIds: id, journeyOrder: journeyOrder || false }));
        }

        this.GetSCORMEducations = function () {
        	return $http.get(siteRootPath + 'api/scormuser/GetEducations');
        };

        this.GetHTML5Education = function(id) {
            return $http.get(siteRootPath + 'api/education/GetHTML5Education?' + $.param({ id: id }));
        };

        this.GetHTML5EducationByUrlRewrite = function(urlRewrite) {
            return $http.get(siteRootPath + 'api/education/GetHTML5EducationByUrlRewrite?' + $.param({ urlRewrite: urlRewrite }));
        };

        this.GetHTML5EducationReply = function(educationId) {
            return $http.get(siteRootPath + 'api/education/GetHTML5EducationReply?' + $.param({ educationId: educationId }));
        };

        this.HTML5ModuleInstanceFinished = function (replyId, containerModuleInstanceId) {
            return $http.post(siteRootPath + 'api/education/HTML5ModuleInstanceFinished?' + $.param({ containerModuleInstanceId: containerModuleInstanceId}), replyId);
        };

        this.SubmitHTML5Education = function (replyId) {
            return $http.post(siteRootPath + 'api/education/SubmitHTML5Education', replyId);
        };

        this.GetTag = function (id) {
            return $http.get(siteRootPath + "api/generictag/getTags?" + $.param({ tagIds: id }));
        }

        this.GetTagBySystemName = function (systemName) {
            return $http.get(siteRootPath + "api/generictag/getTagBySystemName?" + $.param({ tagSystemName: systemName }));
        }
    }

    function replyService() {
        this.OnlineEducationReply = {};
        this.UserStatus = [];
    }
})(window.angular);
